var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIllustrationEnterprise = function SvgIllustrationEnterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4346 31.9542L29.47 36.9898C33.4984 34.5765 38.0779 32.2393 40.1679 30.0731C44.6906 25.5507 42.0684 19.356 42.0684 19.356C42.0684 19.356 35.8737 16.7338 31.3512 21.2562C29.185 23.3464 26.8288 27.9449 24.4346 31.9542Z",
    stroke: "#6A85B6",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0601 19.387L45.2527 16.1943",
    stroke: "#6A85B6",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.537 8.10517C33.141 5.63036 28.9583 4.17017 24.4345 4.17017C13.0732 4.17017 3.86304 13.3803 3.86304 24.7416C3.86304 29.4769 5.46298 33.8385 8.15177 37.3152",
    stroke: "#C3B0EA",
    strokeWidth: 3.42857,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0058 39.4292C15.9798 43.5438 6.62415 47.1363 3.71541 44.5892C2.98113 43.9463 2.81617 42.7899 3.28781 41.1431",
    stroke: "#6A85B6",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.579 31.5754L18.9109 29.6636",
    stroke: "#6A85B6",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6326 36.698L31.2916 42.8571",
    stroke: "#6A85B6",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgIllustrationEnterprise as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDkiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OSA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjQzNDYgMzEuOTU0MkwyOS40NyAzNi45ODk4QzMzLjQ5ODQgMzQuNTc2NSAzOC4wNzc5IDMyLjIzOTMgNDAuMTY3OSAzMC4wNzMxQzQ0LjY5MDYgMjUuNTUwNyA0Mi4wNjg0IDE5LjM1NiA0Mi4wNjg0IDE5LjM1NkM0Mi4wNjg0IDE5LjM1NiAzNS44NzM3IDE2LjczMzggMzEuMzUxMiAyMS4yNTYyQzI5LjE4NSAyMy4zNDY0IDI2LjgyODggMjcuOTQ0OSAyNC40MzQ2IDMxLjk1NDJaIiBzdHJva2U9IiM2QTg1QjYiIHN0cm9rZS13aWR0aD0iMy40Mjg1NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00Mi4wNjAxIDE5LjM4N0w0NS4yNTI3IDE2LjE5NDMiIHN0cm9rZT0iIzZBODVCNiIgc3Ryb2tlLXdpZHRoPSIzLjQyODU3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTM2LjUzNyA4LjEwNTE3QzMzLjE0MSA1LjYzMDM2IDI4Ljk1ODMgNC4xNzAxNyAyNC40MzQ1IDQuMTcwMTdDMTMuMDczMiA0LjE3MDE3IDMuODYzMDQgMTMuMzgwMyAzLjg2MzA0IDI0Ljc0MTZDMy44NjMwNCAyOS40NzY5IDUuNDYyOTggMzMuODM4NSA4LjE1MTc3IDM3LjMxNTIiIHN0cm9rZT0iI0MzQjBFQSIgc3Ryb2tlLXdpZHRoPSIzLjQyODU3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTIxLjAwNTggMzkuNDI5MkMxNS45Nzk4IDQzLjU0MzggNi42MjQxNSA0Ny4xMzYzIDMuNzE1NDEgNDQuNTg5MkMyLjk4MTEzIDQzLjk0NjMgMi44MTYxNyA0Mi43ODk5IDMuMjg3ODEgNDEuMTQzMSIgc3Ryb2tlPSIjNkE4NUI2IiBzdHJva2Utd2lkdGg9IjMuNDI4NTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjQuNTc5IDMxLjU3NTRMMTguOTEwOSAyOS42NjM2IiBzdHJva2U9IiM2QTg1QjYiIHN0cm9rZS13aWR0aD0iMy40Mjg1NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yOS42MzI2IDM2LjY5OEwzMS4yOTE2IDQyLjg1NzEiIHN0cm9rZT0iIzZBODVCNiIgc3Ryb2tlLXdpZHRoPSIzLjQyODU3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";